<script type="text/javascript">
    import UiButton from '@/components/UI/Button/Button.vue';
    import ButtonGroup from '@/components/UI/Button/Group.vue';

    export default {
        UiButton,
        ButtonGroup,
    }
</script>